@let currentPage = currentPage$ | async;
@if (currentPage?.startsWith("/customer-feedback")) {
  <div class="static">
    <app-header [isOnLandingPage]="false" />
    <main class="content">
      <router-outlet />
    </main>
    <app-footer />
  </div>
} @else if (currentPage === "/") {
  <app-header [isOnLandingPage]="true" />
  <main class="content">
    <app-breadcrumbs />
    <router-outlet />
  </main>
  <app-footer />
} @else {
  <app-header [isOnLandingPage]="false" />
  <main class="content">
    <app-breadcrumbs />
    <router-outlet />
  </main>
  @if (!currentPage?.startsWith("/admin")) {
    <app-feedback-fab />
  }
}
<app-toast-container />
